module.exports = __webpack_public_path__ + "static/media/Rectangle 67.e677ba25.png";